import { Card, Form } from 'antd';
import axios from 'axios';
import { useState } from 'react';
import { CiLocationOn } from 'react-icons/ci';
import { useHistory } from 'react-router-dom';

import message from '../../components/message';
import PPPageHeader from '../../components/pageHeader/PPPageHeader';
import { isHandledByInterceptor } from '../../utils/apiError';
import { trimTextFields } from '../../utils/formRules';
import BranchForm from './BranchForm';
import useBranchStore from './branchStore';
import './profilepage.less';

/** Салбарын жагсаалт руу буцах зам (Тохиргооны "Салбарууд" таб) */
const BRANCH_TAB_PATH = { pathname: '/settings', search: '?tab=branch' };

/** Хадгалахын өмнө эхэн/төгсгөлийн илүү зайг цэвэрлэх текст талбарууд */
const TRIMMABLE_TEXT_FIELDS = ['name', 'phoneNumber', 'addressDetail'];

const routes = [
  {
    to: BRANCH_TAB_PATH,
    breadcrumbName: 'Тохиргоо',
  },
  {
    path: 'first',
    breadcrumbName: 'Салбар нэмэх',
  },
];

const CreateBranch = () => {
  const refreshBranchList = useBranchStore((state) => state.refreshBranchList);
  const history = useHistory();
  const [form] = Form.useForm();
  const [addressArray, setAddressArray] = useState([]);
  const [submitting, setSubmitting] = useState(false);

  const onCreate = async () => {
    let values;
    try {
      values = await form.validateFields();
    } catch {
      // Талбарын алдааг Form өөрөө харуулна
      return;
    }

    /**
     * Толгой/сүүлийн зайг тайрч хадгална — эс тэгвээс " Салбар " ба "Салбар"
     * хоёр өөр нэр гэж тооцогдоно.
     */
    const trimmed = { ...values, ...trimTextFields(values, TRIMMABLE_TEXT_FIELDS) };

    setSubmitting(true);
    try {
      const { data } = await axios.post('/api/v1/me/createBranch', {
        name: trimmed?.name,
        phoneNumber: trimmed?.phoneNumber,
        address: addressArray,
        addressDetail: trimmed?.addressDetail,
        /**
         * Газрын зураг дээрээс сонгосон цэг. Өмнө нь координат ХАТУУ бичигдсэн
         * байсан тул салбар бүр ижил байршилтай хадгалагддаг байв —
         * `map_position` нь `BranchLocationPicker`-ийн бөглөдөг `[lat, lon]`.
         */
        location: {
          type: 'Point',
          coordinates: trimmed?.map_position,
        },
      });

      if (data.statusCode === 200) {
        message('Амжилттай бүртгэгдлээ', true);
        refreshBranchList();
        history.push(BRANCH_TAB_PATH);
        return;
      }

      // Алдааны кодтой хариуг interceptor аль хэдийн мэдэгдсэн — давхардуулахгүй
      if (!isHandledByInterceptor(data)) {
        message('Салбар бүртгэхэд алдаа гарлаа');
      }
    } catch (error) {
      console.error('Error creating branch: ', error);
      // Серверийн алдааг interceptor гаргана; сүлжээний алдаа л энд үлдэнэ
      if (!error?.response) {
        message('Салбар бүртгэхэд алдаа гарлаа');
      }
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div>
      <PPPageHeader
        title="Салбар нэмэх"
        breadcrumb={{ routes }}
        onBack={() => history.push(BRANCH_TAB_PATH)}
      />
      <div style={{ padding: 16 }}>
        <Card
          size="middle"
          title={
            <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
              <CiLocationOn style={{ display: 'block', fontSize: '1em' }} />
              Салбарын мэдээлэл
            </span>
          }
        >
          <BranchForm
            addressArray={addressArray}
            setAddressArray={setAddressArray}
            onOk={onCreate}
            form={form}
            submitting={submitting}
          />
        </Card>
      </div>
    </div>
  );
};

export default CreateBranch;
